var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.block.component,{tag:"component",attrs:{"data":_vm.data[_vm.block.dataId]}},_vm._l((_vm.block.children),function(item,index){return _c('block',{key:index,attrs:{"block":item,"data":_vm.data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }